import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Form } from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicTable from "../../components/frame/DynamicTable";
import ReduxAbstract from "../../components/abstract/Redux.abstract";
import { changeInsuranceLedger, selectInsuranceLedger } from "../../actions/salary-allowance-actions";


class InsuranceLedger extends ReduxAbstract {

	initReload = true
	deleteRowSelection = true
	moduleName = "salaryAllowance"
	childModuleName = "insuranceLedger"

	state = {
		currentModalStatus: false,
		currentIndex: null,
		currentData: {},
		currentDataStatus: "unload",
		importModalStatus: false
	}

	actions = {
		changeAction: this.props.changeInsuranceLedger,
		selectAction: this.props.selectInsuranceLedger,
	}

	tableColumn = [{
			title: "保险缴费台账",
			dataIndex: 'account_monthly',
			key: 'account_monthly',
			className: 'table-global-head-short'
		},{
			title: '名称',
			dataIndex: 'insurance_name',
			key: 'insurance_name',
			className: 'table-global-head-short'
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head',
			render: (text, record, index) => {
				return (
					<span>
						<Link to={"/salary-allowance/insurance-ledger/" + record.id}>
							<Button icon="edit" size="small" className="row-action-btn">查看</Button>
						</Link>
					</span>
				);
			} 
		}
	]

	render () {
		return (
			<div className="app-module-item">
				<DynamicTable column={this.tableColumn}
					dataStatus={this.dataSource().dataStatus}
					dataSource={this.dataSource().data.Data}
					pagination={{
						total: this.dataSource().data.Total,
						pageSize: this.dataSource().data.PageSize,
						current: this.dataSource().filters.page}}
					rowSelection={this.rowSelection}
					setPageFilter={this.actions.changeAction} />
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		salaryAllowance: state.salaryAllowance,
	}
}

const mapDispatchToProps = {
	changeInsuranceLedger,
	selectInsuranceLedger,
}

InsuranceLedger = Form.create()(InsuranceLedger);

InsuranceLedger = connect(mapStateToProps, mapDispatchToProps)(InsuranceLedger);

export default LayoutWrapper(InsuranceLedger);




// WEBPACK FOOTER //
// ./src/routes/SalaryAllowance/InsuranceLedger.js